
// create a slice for the case and reducer with state and initial state

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currentCaseId: '',
}


const caseSlice = createSlice({
    name: 'case',
    initialState,
    reducers: {
        setCurrentCaseId: (state, action) => {
            state.currentCaseId = action.payload;
        }
    }
})

export const {
    setCurrentCaseId,
} = caseSlice.actions;
export default caseSlice.reducer;
